module.exports = __webpack_public_path__ + "img/caselist23.2986bf2e.jpg";